import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";
import { toast } from "react-toastify";
import "../styles/AddCenter.css";

const AddCenter = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        centerName: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
        licenseNumber: "",
        timezone: "America/Chicago",
    });

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await api.post("/api/centers", formData);

            console.log("Center created:", res.data);


            navigate("/", { state: { refreshCenters: true } });
        } catch (err) {
            console.error("Create center error:", err);
            toast.error(err.response?.data?.error || "Failed to create center");
        }
    };

    return (
        <div className="add-center-page">
            <h1>Add New Center</h1>

            <form onSubmit={handleSubmit} className="add-center-form">
                <label>Center Name</label>
                <input
                    name="centerName"
                    value={formData.centerName}
                    onChange={handleChange}
                    required
                />

                <label>Address 1</label>
                <input
                    name="address1"
                    value={formData.address1}
                    onChange={handleChange}
                />

                <label>Address 2</label>
                <input
                    name="address2"
                    value={formData.address2}
                    onChange={handleChange}
                />

                <label>City</label>
                <input
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                />

                <label>State</label>
                <input
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                />

                <label>Zip</label>
                <input
                    name="zip"
                    value={formData.zip}
                    onChange={handleChange}
                />

                <label>Phone</label>
                <input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                />

                <label>Email</label>
                <input
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                />

                <label>License Number</label>
                <input
                    name="licenseNumber"
                    value={formData.licenseNumber}
                    onChange={handleChange}
                />

                <label>Timezone</label>
                <input
                    name="timezone"
                    value={formData.timezone}
                    onChange={handleChange}
                />

                <div className="form-actions">
                    <button type="submit">Create Center</button>

                    <button
                        type="button"
                        onClick={() => navigate("/")}
                        className="cancel-btn"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddCenter;